import {
  QueryResponse,
  Service,
  ServiceVersionInput,
  ServiceVersion
} from '@/types';
import gql from 'graphql-tag';
import { ApiService } from '@/services';

export class ServiceService extends ApiService {
  public async getServices(): Promise<QueryResponse<Service[]>> {
    const query = gql`
      query services {
        services {
          id
          name
          description
          dns_name
          slug
          environments
          plans {
            id
            monthly_rate
            plan_id
            plan_name
            plan_type
            limits {
              name
              value
            }
          }
          versions {
            id
            tag
            status
            created_at
          }
          clusters {
            id
            name
            zone
            provider
          }
        }
      }
    `;
    return this.pubQuery<QueryResponse<Service[]>>({ query }, 'services');
  }

  public async createServiceVersion(
    version: ServiceVersionInput
  ): Promise<ServiceVersion> {
    const mutation = gql`
      mutation createServiceVersion($tag: String!, $serviceId: ID!) {
        createServiceVersion(tag: $tag, service_id: $serviceId) {
          id
          tag
          status
          service_id
          created_at
        }
      }
    `;
    return this.mutate(
      { mutation, variables: version },
      'createServiceVersion'
    );
  }
}

export const serviceSvc: ServiceService = new ServiceService();
